import { autoDarkColors } from "@/modules/theme/color/darkModeColor.ts";
import type { ThemeProps, ThemeVarGetters, ThemeVariant } from "@/modules/theme/types.ts";

import png from "@/styles/pilvio/apple-touch-icon.png?url";
import icon from "@/styles/pilvio/favicon.ico?url";
import favicon from "@/styles/pilvio/favicon.svg?url";
import loginIntroBg from "@/styles/pilvio/login-bg.svg?url";
import logoDark from "@/styles/pilvio/logo-dark.svg?url";
import loginLogo from "@/styles/pilvio/logo-login.svg";
import logo from "@/styles/pilvio/logo.svg?url";

export function makeTheme(variant: ThemeVariant) {
    const { isDark } = variant;

    const baseColors: ThemeVarGetters = autoDarkColors({
        "color-primary": "#253AF3",
        "color-secondary": "#e5e5e5",
    });

    return {
        ...baseColors,

        "logo-image": isDark ? `url("${logoDark}")` : `url("${logo}")`,

        "header-logo-width": "64px",
        "header-logo-height": "18px",

        "sidenav-bg-color": isDark ? "transparent" : "#030730",
        "sidenav-item-border": "1px solid transparent",
        "sidenav-item-icon-color": "var(--color-primary)",
        "sidenav-item-bg-color": "transparent",
        "sidenav-item-text-color": "#FFFFFF",
        "sidenav-item-before-width": "1px",
        "sidenav-item-hover-bg-color": "#FFFFFF0C",
        "sidenav-item-hover-icon-color": "var(--color-primary)",
        "sidenav-item-hover-text-color": "#FFFFFF",
        "sidenav-item-active-bg-color": "#FFFFFF19",
        "sidenav-item-active-icon-color": "var(--color-primary)",
        "sidenav-item-active-text-color": "#FFFFFF",
        "sidenav-item-active-before-bg-color": "var(--color-primary)",

        //#region Login
        "login-body-bg-color": "#262EED",
        "login-body-bg-size": "cover",
        "login-body-text-color": "var(--color-text)",
        "login-justify-content": "space-between",
        "login-align-items": "stretch",

        "login-intro-display": "flex",
        "login-intro-bg-image": `url("${loginIntroBg}")`,
        "login-intro-bg-size": "cover",
        "login-intro-bg-position": "50% 50%",
        "login-intro-text-align": "left",
        "login-intro-flex-direction": "column",
        "login-intro-justify-content": "space-between",
        "login-intro-align-items": "flex-start",
        "login-intro-padding": "60px",
        "login-title-font-size": "64px",
        "login-title-text-color": "var(--color-white)",
        "login-title-font-weight": 300,
        "login-title-line-height": 1,
        "login-title-max-width": "",
        "login-title-padding": "0",
        "login-subtitle-font-size": "14px",
        "login-subtitle-max-width": "",

        "login-form-title-font-size": "30px",
        "login-form-input-bg-color": "#FFFFFF",
        "login-form-bg-color": "#0D0F22",
        "login-form-text-color": "var(--color-white)",
        "login-form-input-border-color": "#dbe2e9",
        "login-form-button-border-radius": "var(--button-border-radius)",
        "login-form-or-text-color": "var(--color-white)",
        "login-form-or-border-color": "var(--color-primary)",
        "login-form-google-bg-color": "#D9524F",
        "login-form-more-text-color": "var(--color-white)",
        "login-form-more-bg-color": "transparent",
        "login-form-more-border-color": "var(--color-primary)",
        //#endregion
    } satisfies ThemeVarGetters;
}

export const props: ThemeProps = {
    favicon,
    icon,
    png,
    loginLogoImg: {
        src: loginLogo,
        style: {
            maxWidth: "76px",
        },
    },
};
